import React from 'react';
import { DateTime } from "luxon";

import * as UI from "./ui";

const WinnerSnapshot = ({ flashContest, timezone }) => {
  const winnerSnapshot = flashContest.winnerSnapshot;
  const selectionDate = DateTime.fromISO(winnerSnapshot.drawnAt, { zone: timezone });
  const startDate = DateTime.fromISO(flashContest.beginsAt, { zone: timezone });
  const endDate = DateTime.fromISO(flashContest.endsAt, { zone: timezone });
  const dateRangeString = `${startDate.toLocaleString(DateTime.DATE_SHORT)} - ${endDate.toLocaleString(DateTime.DATE_SHORT)}`;

  return (
    <UI.Layout>
      <UI.Banner aria-label={`${flashContest.name} Contest Information`}>
        <UI.DateRange aria-label="Flash Contest Dates">{dateRangeString}</UI.DateRange>
        <UI.FlashContestName aria-label="Flash Contest Prize Name">{flashContest.name}</UI.FlashContestName>
      </UI.Banner>
      <UI.Info>
        <UI.Section aria-label="Winner Information">
          <UI.Date aria-label="Date winner was drawn">{selectionDate.toLocaleString(DateTime.DATE_MED)}</UI.Date>
          <UI.Name aria-label="Winner Name">{winnerSnapshot.name}</UI.Name>
          <UI.Location aria-label="Winner Location">{winnerSnapshot.location}</UI.Location>
        </UI.Section>
        <UI.Section aria-label="Entry Information">
          <UI.Label>Winning Entry</UI.Label>
          <UI.Number aria-label="Entry Number">{winnerSnapshot.number}</UI.Number>
        </UI.Section>
      </UI.Info>
    </UI.Layout>
  );
}

export default WinnerSnapshot;
